import AuthHelper from 'features/Auth/authHelper';
import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import RoleUtils from 'general/utils/RoleUtils';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';

// Route danh cho tai khoan chua dang nhap (Guest)
// Neu da dang nhap thi nhay ve man hinh root '/'
function GuestRoute(props) {
  // MARK: --- Params ---
  const location = useLocation();
  const isAuth = AuthHelper.checkAccessTokenValid() ?? false;
  const { user } = useSelector((state) => state.auth);
  const savedActiveRole = localStorage.getItem(PreferenceKeys.savedActiveRole);
  const savedUiMode = localStorage.getItem(PreferenceKeys.savedUiMode);
  const pathname = location.pathname.replace(/\/+$/, '');
  const isResetPasswordRoute = pathname === `${AppRoute.auth}/reset-password`;

  if (isResetPasswordRoute) return props.children;

  if (!isAuth) return props.children;

  if (_.isEmpty(user)) {
    AuthHelper.signOut();
    return props.children;
  }

  return RoleUtils.isCustomerUiRole(savedActiveRole, savedUiMode) ? (
    <Navigate to={AppRoute.customerHome} replace />
  ) : (
    <Navigate to="/" replace />
  );
}

export default GuestRoute;
